<template>
<div id="background">
    <div id="top" class="col-xs-12 p-1">
      <router-link v-if="!isMobile()" class="d-flex gift-card-button" :to="{
            name: 'giftcheckbalance',
          }"
        ><img
          src="../../assets/images/button-icons/gift-card.svg"
          alt="gift card balance icon"
        />
        <!-- <img
          src="../assets/button-icons/gift-card-icon.svg"
          alt="gift card balance icon"
          class="mobile"
        /> -->
        Check your Gift Card Balance
      </router-link>
    </div>
  <div id="main-page">
    <div v-if="showHeader" class="d-flex logo-section flex-wrap">
        <img
          :src="currentStoreDoc.Logo"
          alt="abacus logo icon"
          class="logo-icon"
        />
        <router-link
          v-if="isMobile()"
          class="d-flex gift-card-button"
          :to="{
            name: 'giftcheckbalance',
          }"
        >
          <img
            src="../../assets/images/button-icons/gift-card-icon.svg"
            alt="gift card balance icon"
          />
          Check your Gift Card Balance
        </router-link>
        <div class="col-12 col-lg-4 p-0 ml-2">
          <h3 class="title3">{{currentStoreDoc.StoreTitle}}</h3>
          <p class="t-style" :style="{ marginBottom: '0' }">
            {{currentStoreDoc.Name}}
          </p>
          <p class="t-style1">{{currentStoreDoc.Location.Address}}</p>
        </div>
      </div>
    <slot></slot>
  </div>
</div>
</template>

<script lang="ts">
import { mapMutations, mapActions } from "vuex";
import shared from "../../sharedscripts/shop/Checkout/giftCheckout.js";

export default {
  components: {},
  computed: {
    ...shared.computed
  },
  props:{
    showHeader: {
      type: Boolean,
      default: true
    },
    storeid: {
      type: String,
      default: ""
    },
  },
  mounted() {
    this.setStore(this.storeid);
    this.initStore(this.storeid);
    this.getStoreMenu(this.storeid);
  },
  methods: {
      ...mapActions([
        "getStoreMenu",
        "initStore",
        "getStoreMenu",
      ]),
      ...mapMutations(["setStore"]),
  },
};
</script>

<style scoped>
#background {
  background-color: #eeeeee;
  padding-bottom: 100px;
  min-height: 100vh;
}
#top {
  width: 100%;
  height: calc(345 / 1821 * 100vh);
  background-image: url("../../assets/images/gift-top-back.png");
  background-repeat: no-repeat;
  opacity: 1;
}

#main-page {
  padding: 1%;
  border-radius: 2%;
  width: calc(1354 / 1920 * 100vw);
  min-width: 560px;
  background-color: #ffffff;
  margin: auto;
  margin-top: -50px;
}
.logo-section {
  border-bottom: 1px solid rgb(128, 128, 128, 0.3);
  width: 100%;
}
.gift-card-button {
  background-color: #ffffff;
  font-family: Open Sans;
  margin-top: 1%;
  color: black;
  position: absolute;
  right: 13.8%;
}

.logo-icon {
  width: 110px;
  height: fit-content;
}
.main-section__wrapper {
  width: 100%;
  padding: 2% 20%;
  box-sizing: border-box;
}
@media only screen and (max-width: 900px) {
  #background {
    padding-bottom: 0;
  }
  #top {
    display: none;
  }
  .logo-icon {
    height: 90px;
    margin-left: -9px;
  }
  #main-page {
    min-width: 375px;
    padding: 1rem 1rem;
    width: 100%;
    top: 0;
    bottom: 0;
    margin-top: 0;
    height: 100%;
  }
  .gift-card-button {
    top: 20px;
    right: 0;
    color: #55a7ff;
  }
}
@media only screen and (max-width: 600px) {
  .logo-icon {
    height: 70px;
    margin-left: -9px;
  }
}

.t-style {
  font-size: 14px;
  font-weight: normal;
}
.t-style1 {
  font-size: 10px;
  font-weight: 600;
}
</style>
